// Single source of truth for the post-signup subject routing. Used by
// /welcome (subject router page) and /dashboard (FirstStepCard). If a starter
// route ever changes, update it once here and both surfaces stay in sync.

import { Calculator, Books, Atom, Globe } from '@phosphor-icons/react';

export const STARTER_ROUTES = {
  maths: {
    route: '/maths/numbers/bodmas',
    label: 'BODMAS',
    blurb: 'Algebra, number, graphs, ratio, geometry and exam practice',
    icon: Calculator,
    color: 'indigo',
  },
  english: {
    route: '/english/understanding-fiction-and-non-fiction/different-types-of-text',
    label: 'Understanding fiction & non-fiction',
    blurb: 'Reading, writing, literature, analysis and exam technique',
    icon: Books,
    color: 'rose',
  },
  science: {
    route: '/science/biology/gcse-cell-biology',
    label: 'GCSE Cell Biology',
    blurb: 'Biology, chemistry, physics and combined science',
    icon: Atom,
    color: 'emerald',
  },
  geography: {
    route: '/subjects/geography/locational-knowledge/our-world-continents-oceans-and-hemispheres',
    label: 'Our World: Continents, Oceans and Hemispheres',
    blurb: 'Place knowledge, map skills, physical geography and human geography',
    icon: Globe,
    color: 'cyan',
  },
};
